import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PackageCard, ComplianceNote } from "@/components/mlm/PackageCard";

export default function Packages() {
  const [pkgs, setPkgs] = useState([]);
  useEffect(() => {
    api.get("/mlm/packages").then((r) => setPkgs(r.data));
  }, []);
  return (
    <div className="container-x py-16">
      <p className="text-xs font-bold uppercase tracking-widest text-amber-600">Distributor packages</p>
      <h1 className="mt-2 text-4xl font-extrabold tracking-tight sm:text-5xl">Distributor product packages</h1>
      <p className="mt-3 max-w-2xl text-slate-600">Each package contains genuine BMI SP GROUP products. Packages are ordered only by approved distributors from their Distributor Dashboard — registration is free and no purchase is required.</p>
      <ComplianceNote className="mt-6" />
      <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4" data-testid="packages-grid">{pkgs.map((p, i) => <PackageCard key={p.id} pkg={p} index={i} />)}</div>
    </div>
  );
}
